(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/mood-image/assets/javascripts/mood-image.js') >= 0) return;  svs.modules.push('/widgets/mood-image/assets/javascripts/mood-image.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.mood_image = svs.widget.mood_image || {};



 })(window);